import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

/**
 * Generated class for the TranslatorDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[translator]' // Attribute selector
})
export class TranslatorDirective {
  constructor(public ngControl: NgControl) { }

  @HostListener('ngModelChange', ['$event'])
  onModelChange(event) {
    this.onInputChange(event, false);
  }

  @HostListener('keydown.backspace', ['$event'])
  keydownBackspace(event) {
    this.onInputChange(event.target.value, true);
  }
  

  onInputChange(event, backspace) {
    
  }
}



// WEBPACK FOOTER //
// ./src/directives/translator/translator.ts